import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hashPassword, setAdminAuth, checkRateLimit } from '../utils/security';
import './AdminLogin.css';

function AdminLogin() {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    // Rate limiting check
    if (!checkRateLimit()) {
      alert('Too many login attempts. Please wait 15 minutes.');
      return;
    }
    
    setLoading(true);

    try {
      // Hash the entered password
      const hashedPassword = await hashPassword(password);
      const correctHash = await hashPassword(process.env.REACT_APP_ADMIN_PASSWORD);
      
      // Simulate network delay for security
      setTimeout(() => {
        if (hashedPassword === correctHash) {
          setAdminAuth();
          navigate('/iffa-admin-2024');
        } else {
          alert('Invalid password');
          setPassword('');
        }
        setLoading(false);
      }, 800);
    } catch (error) {
      alert('Login error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <div className="login-header">
          <h1>IFFA News</h1>
          <p>Admin Access</p>
        </div>
        
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
              disabled={loading}
            />
          </div>
          
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? 'Authenticating...' : 'Login'}
          </button>
        </form>
        
        <div className="login-footer">
          <small>Authorized personnel only</small>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;